import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ThumberList from '../components/ThumberList';
import ErrorRetry, { LoadingText } from '../components/ErrorRetry';
import NoDetail from '../components/Nodetail';
import Meta from '../components/Meta';
import Pagination from '../components/Pagination'; 
import {BannerAds,GridAds } from '../components/AdsComponent';

const validBasePaths = ['h', 'tags'];
// const validTypenames = ['大陆','三级','日韩','欧美','动漫','短片','漫画','色图','图片','小说',
//   "双飞", "年轻萝莉", "后入式", "口交深喉", "极品女神", "国产AV", "撸管", "舔逼", "自拍偷拍", "网红主播", "奇葩怪癖", "香港三级", "抠逼", "爆乳肥臀", "自慰", "巨乳美臀", "情趣内衣", "教师学生", "特写", "野外车震", "颜射吞精", "凌辱调教", "玩具", "人妻熟女", "角色扮演", "韩国三级", "明星女优", "强奸虐待", "外围技师", "女上位", "野外", "家庭乱伦", "名模空姐", "制服", "白虎", "潮吹", "美腿足交", "医生护士", "百合拉拉", "男同", "下药迷奸", "乳交", "丝袜", "大庭广众", "丰满", "搭讪约炮", "性爱教学", "欧美三级", "威九国际", "痴女痴汉", "威九国际精彩片段", "老汉推车", "美女欣赏", "情侣互动", "破处", "厕所偷拍",
// "国产AV", "北京瑶瑶", "不雅视频流出合辑", "抖音网红合辑", "00后小嫩妹", "5G探花", "勾引外卖小哥系列", "母子乱伦", "SWAG", "上海", "台湾", "职场潜规则", "越南风情", "刘玥", "杭州", "兄妹姐弟不伦恋", "沈阳", "素人系列", "河北", "发情春药系列", "厦门", "三剑客之KTV、足浴城和按摩店", "韩国色片", "和嫂子乱伦", "戴绿帽系列", "港台三级", "富一代CaoB哥", "91的大神们", "网曝门事件", "百度云泄密流出", "有钱人的生活", "冰冰裸替美女沈樵主演", "和小姨子乱伦", "广西", "成都", "澳门", "步兵无码片", "泰国印象", "中文字幕", "湖南", "北京", "南宁", "台北", "云南", "香港", "苏州", "南京", "湖北", "银川", "广东", "AI换脸", "武汉", "新疆", "四川", "深圳", "浙江", "江苏", "真实绿帽", "广州", "真实良家", "福建", "重庆", "天津", "西安", "91推荐", "郑州", "福州", "合肥", "吉林", "贵州", "山东", "8x经典合集", "8x红人系列", "黑龙江", "石家庄", "辽宁", "徐州", "宁夏", "河南", "常州", "海南", "哈尔滨", "贵阳", "长沙", "江西", "老五仔东南亚寻大波妹嫖娼记", "济南", "青海", "丽江", "陕西", "山西", "海口", "太原", "韩国演艺圈卖淫偷拍", "长春", "安徽", "昆明", "无码步兵片", "高颜值美女系列", "一哭二闹三上悠亚", "2D成人动画", "甘肃", "3D成人动画", "交通工具", "复仇", "丛林爱爱法则", "white girl", "中国军阀的性奴", "集団暴力", "穆桂英挂帅", "零号女刑警外传", "拳皇", "天野雨乃", "X学院", "爱憎之灵", "蒂娜", "潜龙", "驱魔侦探", "全国性欲处理委员会", "弱肉强食", "上古-女猎手艾拉", "AV解说", "少妇白洁珍", "手机里的异世界", "cosplay角色扮演", "天使女神", "完全家族崩坏", "我和艳魔的契約", "金莹", "帝国の統", "小早川的故事", "学院迷情", "异世界之泡妞游戏", "隐身恶魔", "欲望爱母", "宅男神域第一季", "无名漫画", "邪派妖女", "隐身虐杀恶魔", "校园奴隶契约", "一不小心掰弯了", "兰州", "无码", "桂林"];

const CategoryList = () => {
  const { basePath, typename, page = 1 } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [validTypenames, setValidTypenames] = useState(['大陆','三级','日韩','欧美','动漫','色漫','图片','小说']);

  useEffect(() => {
    // 读取 /c.json 文件中的 tags 和 series 字段
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/c.json');
        const configData = response.data;
        const tags = configData.tags || [];
        const series = configData.series || [];
        setValidTypenames(prev => [...prev, ...tags, ...series]);
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };

    fetchConfig();
  }, []);

  useEffect(() => {
    // 检查 basePath 和 typename 参数是否有效
    if (!validBasePaths.includes(basePath) || !validTypenames.includes(typename)) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }

    // 检查 page 参数是否为正整数
    if (isValid && !/^[1-9]\d*$/.test(page)) {
      navigate(`/${basePath}/${typename}/1`, { replace: true });
    }
  }, [basePath, typename, page, navigate, isValid, validTypenames]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);

    try {
      await new Promise(resolve => setTimeout(resolve, 50));
      const response = await axios.get(`/list_${basePath}/${typename}/${page}`);
      if (response.data.status === 200) {
        const fetchedData = response.data.data;
        const sanitizedData = fetchedData.map(item => ({
          id: item.id || '1',
          title: item.title || '标题已缺失',
          litpic: item.litpic || '',
          typename: item.typename || '无类别',
        }));
        setData(sanitizedData);
        setIsLastPage(response.data.data.length < 16); // 判断是否为最后一页
      } else {
        console.error('Failed to fetch data:', response.data);
        setError(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [basePath, typename, page]);

  useEffect(() => {
    if (isValid) {
      fetchData();
    }
  }, [fetchData, isValid]);

  if (!isValid) {
    return <NoDetail message={"输入了错误的路径"} />;
  }

  if (loading) {
    return (
      <LoadingText />
    );
  }

  if (error) {
    return <ErrorRetry title={'列表数据'} onClick={fetchData} />;
  }

  // const renderComponent = () => {
  //   if (['大陆','三级','日韩','欧美','动漫','短片','漫画','色图','图片'].includes(typename)) {
  //     return <ThumberList data={data} />;
  //   // } else if (['小说'].includes(typename)) {
  //   //   return <NoThumberList data={data} />;
  //   } else {
  //     return <NoThumberList data={data} />;
  //     //return <NoDetail message={"无此分类"} />;
  //   }
  // };

  return (
    <>
      <Meta title={`${typename}-8x8x`} description={`欢迎来到8x8x，这里是精彩的${typename}内容列表页面，请选择你所喜欢的内容欣赏吧！`} keywords={`${typename}, 8x8x`} />
      <BannerAds />
      <GridAds/>
      <div className="title bg-sc text-tb p-2 md:p-4 text-left mb-4" style={{marginTop:'10px'}}>
        {typename} 列表
      </div>
      {/* {renderComponent()} */}
      <ThumberList data={data} />
      <Pagination basePath={basePath} typename={typename} currentPage={Number(page)} isLastPage={isLastPage} />
    </>
  );
};

export default CategoryList;
